(function(){
"use strict";

angular.module("swapick")
.factory('Entities', Entities);

function Entities(baseServerUrl, $auth, authService, DataService, $q,
    $rootScope, $http, $timeout, store){
    var svc = {  }
    var user = null;

    $rootScope.globals = $rootScope.globals || {};

    var userPromise = $q.defer();
    var categoriel = null;

    svc.getUser = () => user;

    svc.waitForUser = () => {
      return userPromise.promise;
    }
    $rootScope.$on("app:loginSuccess", (evt, data) => {
      if(svc.refreshHandler){
        clearTimeout(svc.refreshHandler)
      }
      svc.loadCurrentUser();
      //#TODO: hardcoded value
      //svc.refreshUserTokenIn(1000);
    });

    $rootScope.$on("app:loginFakeSuccess", (evt, data) => {
      svc.loadFakeUser();
    });



    $rootScope.$on("app:logoutSuccess", (evt, data) => {
      user = null;
      if(svc.refreshHandler){
        clearTimeout(svc.refreshHandler)
      }
      if(svc.userTokenRefreshHandler){
        clearTimeout(svc.userTokenRefreshHandler)
        svc.userTokenRefreshHandler = null;
      }

    });


    svc.loadCurrentUser = function() {
      DataService.me
      .get()
      .then(u => {
          user = u;
          userPromise.resolve(u);
      })
    }

    svc.loadFakeUser = function() {
      user = { id : 1, email : "someone@gmail.com"};
    }


    svc.refreshToken = null;
    svc.refreshHandler = null;
    svc.clientToken = null;

    svc.getClientToken = function(){
      return DataService.getClientToken()
      .then( resp => {
        svc.clientToken = svc.access_token;
        //$http.defaults.headers.common.Authorization = `${resp.token_type} ${resp.access_token}` ;
        $http.defaults.headers.common.Authorization = `Bearer ${resp.access_token}` ;
        svc.refreshHandler = setTimeout(svc.getClientToken, (resp.expires_in - 500) * 1000 );
      })
    };

    //#TODO: move to interceptor
    svc.userTokenRefreshHandler = null;
    svc.setRefreshToken = function(tk){
      store.set("userRefreshToken", tk);
    }
    svc.removeRefreshToken = function(){
      store.remove("userRefreshToken");
    }

    svc.logout = function(){
      svc.removeRefreshToken();
      userPromise = $q.defer();
      user = null;
      $http.defaults.headers.common.Authorization = `Bearer ${svc.clientToken}` ;
      if(svc.userTokenRefreshHandler){
        clearTimeout(svc.userTokenRefreshHandler);
        svc.userTokenRefreshHandler = null;
      }

    }

    svc.refreshUserToken = function(){
      var oldToken = store.get("userRefreshToken");
      return DataService.refreshToken(oldToken)
      .then(resp => {
        //console.error("refreshed", resp);
        $auth.setToken(resp.access_token);
        svc.setRefreshToken(resp.refresh_token);
        svc.refreshUserTokenIn((resp.expires_in - 500)*1000);
      })
    };

    svc.refreshUserTokenIn = function(expiresIn){
      svc.userTokenRefreshHandler = setTimeout(svc.refreshUserToken, expiresIn-500);
    }

    svc.bootstrap = function() {
        return svc.getClientToken()
        .then(function(){
          if ($auth.isAuthenticated()) {
            if(svc.refreshHandler){
              clearTimeout(svc.refreshHandler)
            }
            authService.loginConfirmed();
            //svc.refreshUserTokenIn(1000);
            return svc.loadCurrentUser()
          }
        })
        .catch(err => {
            return svc.refreshUserToken()
            .then(()=>{
              authService.loginConfirmed();
              //svc.refreshUserTokenIn(1000);
              return svc.loadCurrentUser()
            })
        })
    }

    return svc;
}



})();



// WEBPACK FOOTER //
// ./src/services/entities-service.js